import React, { useCallback, useContext, useEffect, useState } from 'react'
import useFetchingData from '../../../_commons/Hooks/useFetchingData';
import useBasicInput from '../../../_commons/Hooks/useHTMLInput';
import { AcademyContext } from '../../../_contexts/UserContext';
import { ILiveNotification, LiveNotificationCMSApi } from '../../../_services/CMSServices/LiveNotificationCMSApi';
import { ILiveNotificationTimedSchedule, LiveNotificationScheduleCMSApi } from '../../../_services/CMSServices/LiveNotificationScheduleCMSApi';
import HTMLCodeEditor from '../../_commons/Editor/HTMLEditor';
import { useLeftRightStyle } from './useLeftRightStyle';
import moment from 'moment';
import { useDynamicContentDialog } from '../../../_commons/Utils/React/Components/Dialogs/SimpleDialog';
import EditLiveNotificationSchedule from './EditLiveNotificationSchedule';
const datetimeFormat="YYYY-MM-DD hh:mm:ss A z";
export default function LiveNotificationEditor(props: { liveNotification: ILiveNotification, onEditSubmit?: (notificationObj: ILiveNotification) => void }) {
    const { liveNotification, onEditSubmit } = props;
    const [isEditing, setIsEditing] = useState<boolean>(false);
    useEffect(() => {
        setIsEditing(false);
    }, [liveNotification])
    return <div>
        <button disabled={isEditing} onClick={() => setIsEditing(true)}>Edit</button>
        {isEditing ?
            <AddOrEditLiveNotification
                notificationObj={liveNotification}
                onSubmit={(notificationObj: ILiveNotification) => onEditSubmit && onEditSubmit(notificationObj)}
            />
            : <DisplayLiveNotification notificationObj={liveNotification} />
        }
        <hr />
        <LiveNotificationSchedule liveNotificationId={liveNotification.liveNotificationId} />
    </div>


}
export function DisplayLiveNotification(props: { notificationObj: ILiveNotification }) {
    const { notificationObj } = props;
    return <div>
        <h6>Title</h6>
        <div>{notificationObj.notificationTitle}</div>
        <h6>Content</h6>
        <div dangerouslySetInnerHTML={{ __html: notificationObj.notificationContent }} />

    </div>
}
export function AddOrEditLiveNotification(props: { notificationObj?: ILiveNotification, onSubmit?: (notificationObj: ILiveNotification) => void }) {
    const { notificationObj, onSubmit } = props;
    const [notification, setNotification] = useState<ILiveNotification>(notificationObj ?? {
        liveNotificationId: 0,
        notificationContent: "",
        notificationTitle: ""
    });

    const handleTitleChange = (title: string) => {
        setNotification(n => { return { ...n, notificationTitle: title } })
    }
    return <div>
        {notification.liveNotificationId === 0 ? "Add" : "Edit"} Notification
        <div>
            <h6>Title</h6>
            <input
                type="text"
                value={notification.notificationTitle}
                onChange={(e) => handleTitleChange(e.target.value)}
            />

        </div>
        <h6>Content</h6>
        <HTMLCodeEditor
            defaultHtmlStr={notification.notificationContent}
            htmlStrSetter={(value) => setNotification(n => { return { ...n, notificationContent: value } })}
        />
        <div>
            <button
                onClick={() => onSubmit && onSubmit(notification)}
                disabled={notification.notificationTitle === "" || notification.notificationContent === ""}>
                Save
            </button>
        </div>
    </div>
}
function LiveNotificationSchedule(props: { liveNotificationId: number }) {
    const { loginState: { accessToken } } = useContext(AcademyContext);
    const token = accessToken ?? "";
    const { liveNotificationId } = props;
    const useDialog = useDynamicContentDialog({ maxWidth: 'lg', disableBackdropClick: true });


    const [timeStringToAdd, setTimeStringToAdd] = useState<string>();
    const { data: objs, handleRefresh: refreshData } = useFetchingData<ILiveNotificationTimedSchedule[]>(

        useCallback(
            (setData) => {
                LiveNotificationScheduleCMSApi.GetAll(liveNotificationId, token).then((data) => {
                    if (data)
                        setData(data);
                    else
                        setData(null);
                }).catch(() => {
                    setData(null);
                })
            },
            [liveNotificationId, token],
        )
    )
    const handleAddSchedule = useCallback(
        (dateStr: string) => {
            if (window.confirm(`Add a new schedule:${moment.utc(dateStr).format(datetimeFormat)}`)) {
                accessToken && LiveNotificationScheduleCMSApi.Update("ADD", {
                    scheduleId: 0,
                    liveNotificationId: liveNotificationId,
                    expectedRunDateTime: moment.utc(dateStr).toDate(),
                    actualRunDateTime: null
                }, accessToken)
                .finally(()=>{
                    refreshData();
                })
            }
        },
        [accessToken, liveNotificationId]
    )
    const handleOpenEdit = (scheduleId: number) => {
        useDialog.open(
            <EditLiveNotificationSchedule
                saveHandler={(newDatetimeStr: string) => {
                    if (window.confirm(`Update this schedule to:${moment.utc(newDatetimeStr).format(datetimeFormat)}`)) {
                        accessToken &&
                            LiveNotificationScheduleCMSApi.Update("EDIT",
                                {
                                    scheduleId: scheduleId,
                                    liveNotificationId: liveNotificationId,
                                    expectedRunDateTime: moment.utc(newDatetimeStr).toDate(),
                                    actualRunDateTime: null
                                },
                                accessToken

                            ).finally(
                                ()=>{
                                    useDialog.close();
                                    refreshData();
                                }
                            )
                    }

                }}
                cancleHandler={() => useDialog.close()}

            />

        )
    }
    const handleDelete = (scheduleId: number) => {
        if (window.confirm(
            "confirm to delete?"
        )) {
            accessToken &&
                LiveNotificationScheduleCMSApi.Delete(
                    {
                        id: scheduleId
                    }
                    ,
                    accessToken

                ).finally(()=>{
                    refreshData();
                })
        }


    }
    return objs === undefined ? <div>Loading</div> :
        objs === null ? <div>Error</div> :
            <div>


                Add a Schedule: Select a UTC time:
                <input
                    type="datetime-local"
                    value={timeStringToAdd}
                    onChange={(e) => { setTimeStringToAdd(e.target.value) }}
                    min={moment.utc().format("YYYY-MM-DDThh:mm")}

                />
                <button onClick={() => timeStringToAdd && handleAddSchedule(timeStringToAdd)} disabled={timeStringToAdd === undefined}>Submit</button>


                <table>
                    <thead>
                        <tr>
                            <td>Expected Time to Run </td>
                            <td>Actual Time of Runnig </td>
                            <td colSpan={2}>Actions </td>
                        </tr>
                    </thead>
                    <tbody>
                        {objs.sort((a, b) => b.expectedRunDateTime > a.expectedRunDateTime ? 1 : -1).map((obj, index) => {
                            return <tr key={obj.scheduleId}>
                                <td>{moment.utc(obj.expectedRunDateTime).format(datetimeFormat)}</td>
                                <td>
                                    {
                                        obj.actualRunDateTime ?
                                            `Run at: ${moment.utc(obj.actualRunDateTime).format(datetimeFormat)}`
                                            : `To run: ${moment.utc(obj.expectedRunDateTime).fromNow()}`
                                    }
                                </td>
                                <td >
                                    <button
                                        onClick={() => handleOpenEdit(obj.scheduleId)}
                                        disabled={obj.actualRunDateTime != null}
                                    >
                                        Edit
                                    </button>
                                </td>
                                <td >
                                    <button
                                        onClick={() => handleDelete(obj.scheduleId)}
                                        disabled={obj.actualRunDateTime != null}
                                    >
                                        Delete
                                    </button>
                                </td>

                            </tr>
                        })}
                    </tbody>
                </table>
                {useDialog.render()}
            </div>
}
